import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const userSavedViewsQuery = graphql(/* GraphQL */ `
  query UserSavedViewsByKeys($keys: [String!]!) {
    userSavedViews(keys: $keys) {
      key
      value
    }
  }
`);

export const upsertUserSavedViewsMutation = graphql(/* GraphQL */ `
  mutation UpsertUserSavedViews($input: UpsertUserSavedViewsInput!) {
    upsertUserSavedViews(input: $input) {
      success
    }
  }
`);

export type UserSavedViewsByKeysData = ResultOf<typeof userSavedViewsQuery>;
export type UserSavedViewsByKeysVariables = VariablesOf<typeof userSavedViewsQuery>;
export type UpsertUserSavedViewsData = ResultOf<typeof upsertUserSavedViewsMutation>;
export type UpsertUserSavedViewsVariables = VariablesOf<typeof upsertUserSavedViewsMutation>;

export type SavedViewValue = UserSavedViewsByKeysData['userSavedViews'][number]['value'];
export type SavedViewEntries = UpsertUserSavedViewsVariables['input']['savedViews'];
